<ideal-drawer position="left" [open]="navStore.menuOpen()">
  <div class="container">
    <ideal-render-target-secondary-navigation-frame />
    <div class="scroll-container">
      <ideal-navigation-list [items]="navStore.navChildren()"></ideal-navigation-list>
      <ideal-render-target-secondary-navigation />
    </div>
  </div>
</ideal-drawer>
